import { useTranslation } from "react-i18next";
import { type FieldErrorDto } from "../../../../../../autogen/bff-api";
import { useDisplayDate } from "../../../../../../common/formatting/useDisplayDate";
import { refusedFieldErrors } from "../../../../../../common/redux/reducers/contractReducer";
import { type EditContractCommandType } from "../../../../../../common/redux/thunks/contract/edit-contract-thunk";
import { useExtensionName } from "../../../../options/extensionName";
import { useContractState } from "../../../useContractState";

const DEADLINE_BEFORE_START = "zz_ContractApiErrorCode_OptionDeadlineBeforeContractStart";

export const useDeadlineBeforeStartExplanation = (): ((errors: FieldErrorDto[]) => string | null) => {
  const { t } = useTranslation();
  const displayDate = useDisplayDate();
  const contractState = useContractState();
  const nameOf = useExtensionName(contractState.contract.dataFields.options ?? []);
  return (errors) => {
    const refusals = errors.filter((error) => error.code === DEADLINE_BEFORE_START);
    if (refusals.length === 0) return null;
    return refusals
      .map((refusal) =>
        t("The deadline to exercise {{name}} would be {{deadline}}, before the contract starts on {{start}}.", {
          name: nameOf({ id: refusal.params?.optionId, name: refusal.params?.name }),
          deadline: displayDate(refusal.params?.deadline ?? ""),
          start: displayDate(refusal.params?.contractStart ?? ""),
        })
      )
      .join(" ");
  };
};

export const useDeadlineBeforeStartRefusal = (type: EditContractCommandType): string | null => {
  const explain = useDeadlineBeforeStartExplanation();
  return explain(refusedFieldErrors(useContractState(), type));
};
